// The Avenue School/the-avenue-school/client/src/components/EventsSection.js
import React from "react";
import PropTypes from "prop-types";
import "../styles/events2.css";

/**
 * EventsSection (presentational)
 *
 * Figma-aligned visual for the events list.
 * Keeps DOM simple/semantic so the container can swap in any data source.
 *
 * A11y:
 * - <h2> section heading provided by `title`
 * - List semantics <ul>/<li>
 * - CTA has aria-label per item
 *
 * NOTE: Uses static assets by default for the decorative leaves.
 * TODO: If you have design tokens for colors/spacing/typography, replace magic values in CSS.
 */
const EventsSection = ({
  title = "Upcoming Events",
  leftDecor = "/media/light-sage-leaf.png",
  rightDecor = "/media/light-sage-leaf.png",
  events = [],
}) => {
  return (
    <section className="events" aria-labelledby="events-heading">
      {/* Decorative images (behind content) */}
      <img
        className="events-decor events-decor--left"
        src={leftDecor}
        alt=""
        aria-hidden="true"
      />
      <img
        className="events-decor events-decor--right"
        src={rightDecor}
        alt=""
        aria-hidden="true"
      />

      <h2 id="events-heading" className="events-title">{title}</h2>

      <ul className="events-list" role="list">
        {events.map((e, i) => (
          <li key={`${e.day}-${e.mon}-${i}`} className="event-card">
            <div className="event-date">
              <div className="event-day">{e.day}</div>
              <div className="event-mon">{e.mon}</div>
            </div>

            <div className="event-main">
              <div className="event-name">{e.title}</div>
              <a
                className="event-cta"
                href={e.href || "#"}
                aria-label={`More about ${e.title}`}
              >
                <img src="/media/icons/arrow.svg" alt="" aria-hidden="true" />
              </a>
            </div>
          </li>
        ))}
      </ul>

      {events.length === 0 && (
        <div className="events-empty" role="status" aria-live="polite">
          {/* Simple empty state; container decides when this shows */}
          Nothing to show yet—please check back soon.
        </div>
      )}
    </section>
  );
};

EventsSection.propTypes = {
  title: PropTypes.string,
  leftDecor: PropTypes.string,
  rightDecor: PropTypes.string,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.string.isRequired,
      mon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      href: PropTypes.string,
    })
  ),
};

export default EventsSection;
